import { Paper, styled } from "@mui/material";

const TablePaper = styled(Paper)(({ theme }) => ({
    overflow: 'hidden',
    '& > .MuiPaper-root': {
        margin: '0 1.5rem 1rem',
        width: 'auto',
        flex: 1
    }
}));

export default TablePaper;